// eslint-disable-next-line import/prefer-default-export
export function getConsumptionTypeLabel(consumptionType, i18n) {
    if (!consumptionType)
        return '';
    return i18n.language === 'en' ? consumptionType.labelEN : consumptionType.labelPL;
}
